import axios from "axios";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import swal from 'sweetalert';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UseFullPageLoader from "../../FullPageLoader/UseFullPageLoader";


const AddPage = () => {
    document.title = "DirtMap - Add Page";

    const history = useHistory();
    const [pageInput, setPageInput] = useState({
        title: '',
        url: '',
        description: '',
        error_list: [],
    })
    const [loader, showLoader, hideLoader] = UseFullPageLoader();
    


    const handleInput = (e) => {
        e.persist();
        setPageInput({ ...pageInput, [e.target.name]: e.target.value });
    }

    const handleEditorOnChange = (e, editor) => {
        const data = editor.getData();
        console.log( { e, editor, data } );
        setPageInput({ ...pageInput, description:data });
    }

    const submitPage = (e) => {

        e.preventDefault();


        const data = {
            title: pageInput.title,
            url: pageInput.url,
            description: pageInput.description,
        }
        showLoader();
        axios.get('/sanctum/csrf-cookie').then(res => {
            axios.post(`/api/create/cms/page`, data).then(res => {
                if (res.data.success === true) {
                    hideLoader();
                    swal("success", "Page Created Sucessfully Done", "success");
                    history.push('/admin/page/index');
                }
                else {
                    hideLoader();
                    setPageInput({ ...pageInput, error_list: res.data.errors });
                }
            });
        });
    }


    return (
        <div className="container-fluid">
            <div className="card shadow mb-4">
                <div className="card-header py-3">
                    <h4 className="card-title mb-0">Create Page</h4>
                </div>
                <div className="card-body">
                    <form onSubmit={submitPage}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">Title</label>
                                    <input type="text" name="title" onChange={handleInput} value={pageInput.title} className="form-control" placeholder="Enter Page Title" />
                                    <span className="validate-error-message">{pageInput.error_list.title}</span>

                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="name">Url</label>
                                    <input type="text" name="url" onChange={handleInput} value={pageInput.url} className="form-control" placeholder="Enter Page Url" />
                                    <span className="validate-error-message">{pageInput.error_list.url}</span>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label htmlFor="userName">Description</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        onChange={handleEditorOnChange}
                                        value={pageInput.description}

                                    />
                                    {/* <textarea type="text" name="description" onChange={handleInput} value={pageInput.description} className="form-control" placeholder="Enter Page Content" /> */}
                                   
                                    <span className="validate-error-message">{pageInput.error_list.description}</span>
                                </div>
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col-md-12 text-right">
                                <button type="submit" className="btn btn-primary">Create</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            {loader}
        </div>
    );
}
export default AddPage;